import { z } from 'zod'

/* Message & Task Type */
export const [
  MESSAGE_TYPE_GOAL,
  MESSAGE_TYPE_THINKING,
  MESSAGE_TYPE_TASK,
  MESSAGE_TYPE_ACTION,
  MESSAGE_TYPE_SYSTEM,
  MESSAGE_TYPE_USER_INPUT,
  MESSAGE_TYPE_INIT,
  MESSAGE_TYPE_API,
  MESSAGE_TYPE_INTERMEDIATE_ANSWER,
  MESSAGE_TYPE_INTERMEDIATE_ANSWER_STREAM,
  MESSAGE_TYPE_FINAL_ANSWER,
  MESSAGE_TYPE_FINAL_ANSWER_STREAM,
  MESSAGE_TYPE_TOOL_MESSAGE,
  MESSAGE_TYPE_TOOL_CALL,
  MESSAGE_TYPE_TOOL_ERROR,
  MESSAGE_TYPE_LLM_ERROR,
] = [
  'goal',
  'thinking',
  'task',
  'action',
  'system',
  'userInput',
  'init',
  'apiMessage',
  'intermediateAnswer',
  'intermediateAnswerStream',
  'finalAnswer',
  'finalAnswerStream',
  'toolMessage',
  'toolCall',
  'toolError',
  'llmError',
]

export type MessageType =
  | typeof MESSAGE_TYPE_GOAL
  | typeof MESSAGE_TYPE_THINKING
  | typeof MESSAGE_TYPE_TASK
  | typeof MESSAGE_TYPE_ACTION
  | typeof MESSAGE_TYPE_SYSTEM
  | typeof MESSAGE_TYPE_USER_INPUT
  | typeof MESSAGE_TYPE_INIT
  | typeof MESSAGE_TYPE_API
  | typeof MESSAGE_TYPE_INTERMEDIATE_ANSWER
  | typeof MESSAGE_TYPE_INTERMEDIATE_ANSWER_STREAM
  | typeof MESSAGE_TYPE_FINAL_ANSWER
  | typeof MESSAGE_TYPE_FINAL_ANSWER_STREAM
  | typeof MESSAGE_TYPE_LLM_ERROR

export const [
  TASK_STATUS_STARTED,
  TASK_STATUS_EXECUTING,
  TASK_STATUS_COMPLETED,
  TASK_STATUS_FINAL,
  TASK_STATUS_RESULT_SUMMARIZED,
  TASK_STATUS_FAILED,
] = ['started', 'executing', 'completed', 'final', 'result_summarized', 'failed']

export const [TOOL_PLAN] = ['plan']

const TaskStatusSchema = z.union([
  z.literal(TASK_STATUS_STARTED),
  z.literal(TASK_STATUS_EXECUTING),
  z.literal(TASK_STATUS_COMPLETED),
  z.literal(TASK_STATUS_FINAL),
  z.literal(TASK_STATUS_RESULT_SUMMARIZED),
  z.literal(''),
])

export type TaskStatus = z.infer<typeof TaskStatusSchema>

export const messageSchemaBase = z.object({
  value: z.string(),
  info: z.string().optional().nullable(),
})

export const taskSchema = z
  .object({
    taskId: z.string().optional(),
    type: z.literal(MESSAGE_TYPE_TASK),
    status: TaskStatusSchema,
  })
  .merge(messageSchemaBase)

export const nonTaskScehma = z
  .object({
    type: z.union([
      z.literal(MESSAGE_TYPE_GOAL),
      z.literal(MESSAGE_TYPE_THINKING),
      z.literal(MESSAGE_TYPE_ACTION),
      z.literal(MESSAGE_TYPE_SYSTEM),
    ]),
  })
  .merge(messageSchemaBase)

export const messageSchema = z.union([taskSchema, nonTaskScehma])

export type TaskMessage = z.infer<typeof taskSchema>

/* Type Predicates */
export const isTask = (value: any): value is TaskMessage => {
  try {
    taskSchema.parse(value)
    return true
  } catch (err) {
    return false
  }
}

/* Helper Functions */
export const getTaskStatus = (value: any) => {
  if (!isTask(value)) {
    return
  }

  return value.status
}

export const isAction = (value: any) => {
  return isTask(value) && value.status === TASK_STATUS_COMPLETED
}

export const agentType = {
  mrklAgentChat: 'mrklAgentChat',
  reportAgent: 'reportAgent',
  planAndExecuteAgent: 'planAndExecuteAgent',
  torqAGI: 'torqAGI',
}

export const SWR_SESSION_FILES_KEY = 'session-files'

export const configBlockType = {
  prompts: 'Prompts',
  data: 'Data',
  tools: 'Tools',
}
